export default "__VITE_ASSET__kdg76e43__"